export const getCompliance = (state, patientId) =>
  state.patients.patientCompliances.byPatientId[patientId];

export const getComplianceDetails = state =>
  state.patients.complianceDetails.data;
